import { useMutation, QueryOptions } from "react-query";

import {
  touchIDAgentsService,
  getTouchIDInfoAgentsService,
} from "./touch-service";
import {
  IGetTouchIDService,
  IGetTouchIDInfoService,
} from "./use-touch.interface";

export const useTouchIDAgentsService = (config?: QueryOptions) => {
  return useMutation(
    (data: IGetTouchIDService) => touchIDAgentsService(data).then((res) => res),
    config,
  );
};

export const useTouchIDInfoAgentsService = (config?: QueryOptions) => {
  return useMutation(
    (data: IGetTouchIDInfoService) =>
      getTouchIDInfoAgentsService(data).then((res) => res),
    config,
  );
};
